(function() {

  var SEC_PER_DAY = 86400;

  function parseJSONSafe(value) {
    if (!value) return null;
    try {
      return typeof value === 'string' ? JSON.parse(value) : value;
    } catch (err) {
      return null;
    }
  }

  function toNumber(val) {
    var num = parseInt(val, 10);
    return isNaN(num) ? 0 : num;
  }

  function escapeHtml(value) {
    return (value || '').toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeRegion(region) {
    var val = (region || '').toString().toUpperCase();
    if (val === 'US' || val === 'USA' || val === 'UNITED STATES') return 'US';
    if (val === 'CA' || val === 'CANADA') return 'CA';
    return val || 'BOTH';
  }

  function bumpWeekend(ts, holidaySet) {
    var date = new Date(ts * 1000);
    var dow = date.getDay();

    if (!holidaySet) {
      if (dow === 6) {
        date.setDate(date.getDate() + 2);
      } else if (dow === 0) {
        date.setDate(date.getDate() + 1);
      }
      return Math.floor(date.getTime() / 1000);
    }

    // v3, calendar present: skip weekends AND our closure dates, cascading.
    var guard = 0;
    while (guard++ < 21) {
      dow = date.getDay();
      var iso = localIsoOf(Math.floor(date.getTime() / 1000));
      if (dow !== 0 && dow !== 6 && holidaySet[iso] !== 1) break;
      date.setDate(date.getDate() + 1);
    }
    return Math.floor(date.getTime() / 1000);
  }

  function countBusinessDaysBetween(startTs, endTs) {
    var startDate = new Date((startTs || Date.now() / 1000) * 1000);
    var endDate = new Date((endTs || startTs || Date.now() / 1000) * 1000);

    startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());

    if (endDate <= startDate) return 0;

    var businessDays = 0;
    var cursor = new Date(startDate);

    while (cursor < endDate) {
      cursor.setDate(cursor.getDate() + 1);
      var dow = cursor.getDay();
      if (dow !== 0 && dow !== 6) {
        businessDays += 1;
      }
    }

    return businessDays;
  }

  // ---------------------------------------------------------------------
  // ETA v3: Toronto-anchored calendar machinery (Layer A + Layer B).
  // Everything here is INERT unless config.etaCalendar is provided, which the
  // theme only does on the .ca market. See ETA-V3-HANDOFF.md.
  // ---------------------------------------------------------------------
  var TORONTO_FMT = null;
  function torontoParts(ts) {
    if (TORONTO_FMT === null) {
      try {
        TORONTO_FMT = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'America/Toronto',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short'
        });
      } catch (err) { TORONTO_FMT = false; }
    }
    if (!TORONTO_FMT) return null;
    var parts = {};
    TORONTO_FMT.formatToParts(new Date(ts * 1000)).forEach(function (pt) {
      parts[pt.type] = pt.value;
    });
    var dowMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    var hour = parseInt(parts.hour, 10);
    if (hour === 24) hour = 0;
    return {
      iso: parts.year + '-' + parts.month + '-' + parts.day,
      dow: dowMap[(parts.weekday || '').slice(0, 3)],
      hour: hour,
      minute: parseInt(parts.minute, 10) || 0
    };
  }

  function isoAddDays(iso, n) {
    var t = Date.parse(iso + 'T00:00:00Z') + n * 86400000;
    return new Date(t).toISOString().slice(0, 10);
  }
  function isoDow(iso) {
    return new Date(Date.parse(iso + 'T00:00:00Z')).getUTCDay();
  }
  function localIsoOf(ts) {
    var d = new Date(ts * 1000);
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }
  function fmtIsoShort(iso) {
    return new Date(iso + 'T12:00:00Z').toLocaleDateString('en-US', {
      timeZone: 'UTC', month: 'short', day: '2-digit', year: 'numeric'
    });
  }
  function fmtIsoLong(iso) {
    return new Date(iso + 'T12:00:00Z').toLocaleDateString('en-US', {
      timeZone: 'UTC', month: 'long', day: 'numeric', year: 'numeric'
    });
  }

  // config.etaCalendar = { onClosed: [ISO...], usClosed: [ISO...] }
  function calendarSets(cal) {
    if (!cal) return null;
    function toSet(arr) {
      var out = {};
      (Array.isArray(arr) ? arr : []).forEach(function (x) {
        if (x) out[String(x).slice(0, 10)] = 1;
      });
      return out;
    }
    return { on: toSet(cal.onClosed), us: toSet(cal.usClosed) };
  }

  // Layer A: nominal Friday ship day -> actual ship day.
  // Decision 10: Friday closure ships Monday, cascading to the next OPEN day.
  // Decision 11: Wednesday RECEIVE closure also ships Monday.
  function resolveShipDay(nomFriIso, recvWedIso, sets) {
    var candidate = nomFriIso;
    if (sets) {
      var monday = isoAddDays(nomFriIso, 3);
      if (recvWedIso && sets.on[recvWedIso] === 1) candidate = monday;
      if (sets.on[nomFriIso] === 1 && monday > candidate) candidate = monday;
      if (sets.on[nomFriIso] === 1 && candidate === nomFriIso) candidate = monday;
      var guard = 0;
      while (guard++ < 21 &&
        (isoDow(candidate) === 0 || isoDow(candidate) === 6 || sets.on[candidate] === 1)) {
        candidate = isoAddDays(candidate, 1);
      }
    }
    return candidate;
  }

  // Layer B: the T14 weekly inbound cycle. PA/IN/TX cut off Friday noon
  // Toronto (+7d to ship); NV cuts off Wednesday noon (+9d). Cutoffs on a
  // closure move EARLIER (decisions 12/13): Friday cutoffs shift on US
  // holidays; the NV Wednesday cutoff shifts on any closure, ours or theirs.
  function computeT14CycleShip(state, nowTs, sets) {
    var tp = torontoParts(nowTs);
    if (!tp || !sets) return null;
    var isNV = state === 'NV';
    var cutDow = isNV ? 3 : 5;
    var shipOffset = isNV ? 9 : 7;
    var recvOffset = isNV ? 7 : 5;
    for (var k = 0; k < 42; k++) {
      var iso = isoAddDays(tp.iso, k);
      if (isoDow(iso) !== cutDow) continue;
      var eff = iso, guard = 0;
      while (guard++ < 7) {
        var closed = isNV
          ? (sets.on[eff] === 1 || sets.us[eff] === 1)
          : (sets.us[eff] === 1);
        if (!closed) break;
        eff = isoAddDays(eff, -1);
      }
      var catches = tp.iso < eff || (tp.iso === eff && tp.hour < 12);
      if (!catches) continue;
      var nominalShip = isoAddDays(iso, shipOffset);
      var receiveIso = isoAddDays(iso, recvOffset);
      var shipIso = resolveShipDay(nominalShip, receiveIso, sets);
      return {
        shipIso: shipIso,
        shipTs: Date.parse(shipIso + 'T16:00:00Z') / 1000,
        nominalCutoff: iso,
        effectiveCutoff: eff,
        receiveIso: receiveIso,
        state: state
      };
    }
    return null;
  }

  function extractField(obj, key) {
    if (!obj) return undefined;
    if (typeof obj[key] !== 'undefined') return obj[key];
    if (obj.value && typeof obj.value[key] !== 'undefined') return obj.value[key];
    if (obj.fields && obj.fields[key]) {
      var f = obj.fields[key];
      if (typeof f.value !== 'undefined') return f.value;
      if (typeof f.reference !== 'undefined') return f.reference;
    }
    return undefined;
  }

  function computeDisplayDate(daysFromToday, startTs, holidaySet) {
    return computeBusinessDisplayDate(daysFromToday, startTs, holidaySet);
  }

  function computeBusinessDisplayDate(businessDaysFromToday, startTs, holidaySet) {
    var date = new Date((startTs || Date.now() / 1000) * 1000);
    var daysAdded = 0;
    var targetBusinessDays = Math.max(0, businessDaysFromToday);

    while (daysAdded < targetBusinessDays) {
      date.setDate(date.getDate() + 1);
      var dow = date.getDay();
      if (dow !== 0 && dow !== 6) {
        if (!holidaySet || holidaySet[localIsoOf(Math.floor(date.getTime() / 1000))] !== 1) {
          daysAdded += 1;
        }
      }
    }

    return bumpWeekend(Math.floor(date.getTime() / 1000), holidaySet);
  }

  function buildInventoryMap(raw, variantId) {
    var parsed = parseJSONSafe(raw) || {};
    var source = parsed && parsed.value ? parsed.value : parsed;

    if (!source || typeof source !== 'object') return {};

    var locations = source.locations;
    if (locations && typeof locations === 'object') return locations;

    var variantKey = typeof variantId === 'undefined' || variantId === null ? null : variantId.toString();
    var variants = source.variants;
    if (variants && typeof variants === 'object' && variantKey) {
      var variantEntry = variants[variantKey] || variants[variantId];
      var variantLocations = variantEntry && (variantEntry.locations || variantEntry);
      if (variantLocations && typeof variantLocations === 'object') return variantLocations;
    }

    var productLocations = source.productLocations;
    if (productLocations && typeof productLocations === 'object') return productLocations;

    return {};
  }

  function selectWarehouses(config) {
  var inventoryByLocation = buildInventoryMap(config.inventoryMap, config.inventoryVariantId);
  var candidates = [];
  var market = config.market === 'US' ? 'US' : 'CA';
  var sources = Array.isArray(config.fulfillmentSources)
    ? config.fulfillmentSources
    : [];

  // --- DEBUG STEP 1: what are we working with? ---
  console.log('[ETA][WH] inventoryByLocation:', inventoryByLocation, 'raw:', config.inventoryMap, 'variantId:', config.inventoryVariantId);
  console.log('[ETA][WH] market:', market);
  console.log('[ETA][WH] fulfillmentSources count:', sources.length);
  // -----------------------------------------------

  sources.forEach(function(source, idx) {
    if (!source) return;
    var enabled = extractField(source, 'enabled');
    if (!(enabled === true || enabled === 1 || enabled === '1' || enabled === 'true')) return;

    var region = normalizeRegion(extractField(source, 'region_visibility'));
    if (!(region === 'BOTH' || region === market)) return;

    var locationId = extractField(source, 'shopify_location_id');
    if (!locationId) return;

    var qty = toNumber(inventoryByLocation[locationId] || 0);
    if (qty <= 0) return;

    var displayAsStore = extractField(source, 'display_as_store');
    var storeLink = extractField(source, 'store_link');
    var fixedDays = toNumber(extractField(source, 'fixed_shipping_days'));
    var bufferDays = toNumber(extractField(source, 'buffer_days'));
    var maxDisplayQty = extractField(source, 'max_display_quantity');
    var combineSameEta = extractField(source, 'combine_quantity_when_same_eta');
    var sourceName = extractField(source, 'name') || extractField(source, 'key') || 'Warehouse';
    var sourceIdentifier = [
      extractField(source, 'key'),
      extractField(source, 'handle'),
      extractField(source, 'internal_key'),
      sourceName,
      locationId
    ].join('|').toLowerCase();
    var isManufacturerInventorySource =
      sourceIdentifier.indexOf('manufacturer-inventory') !== -1 ||
      sourceIdentifier.indexOf('manufacturer inventory') !== -1 ||
      sourceIdentifier.indexOf('ford-racing-inventory') !== -1 ||
      sourceIdentifier.indexOf('ford racing inventory') !== -1 ||
      sourceIdentifier.indexOf('116224393579') !== -1;
    var isExternalWarehouseSource =
      sourceIdentifier.indexOf('wheelpros-us') !== -1 ||
      sourceIdentifier.indexOf('wheelpros us') !== -1 ||
      sourceIdentifier.indexOf('wheelpros_us') !== -1 ||
      sourceIdentifier.indexOf('115961135467') !== -1;

    var etaDays = fixedDays + bufferDays;
    var etaTs = computeDisplayDate(etaDays, config.todayTs, config.holidaySet);
    candidates.push({
      shipByISO: localIsoOf(etaTs),
      idx: idx,
      etaDays: etaDays,
      etaTs: etaTs,
      qty: qty,
      name: sourceName,
      maxDisplayQty: typeof maxDisplayQty === 'number' ? maxDisplayQty : toNumber(maxDisplayQty),
      combineSameEta: combineSameEta === true || combineSameEta === 'true' || combineSameEta === 1 || combineSameEta === '1',
      displayAsStore: displayAsStore === true || displayAsStore === 'true' || displayAsStore === 1 || displayAsStore === '1',
      storeLink: storeLink,
      isManufacturerInventorySource: isManufacturerInventorySource,
      isExternalWarehouseSource: isExternalWarehouseSource
    });
  });

  // --- DEBUG STEP 1: did we get any candidates at all? ---
  console.log('[ETA][WH] candidates after filtering:', candidates);
  // -------------------------------------------------------

  if (!candidates.length) return null;

  candidates.sort(function(a, b) {
    if (a.etaDays === b.etaDays) return a.idx - b.idx;
    return a.etaDays - b.etaDays;
  });

  var best = candidates[0];
  var combinedQty = best.qty;
  if (best.combineSameEta) {
    candidates.forEach(function(entry, i) {
      if (i === 0) return;
      if (entry.etaTs === best.etaTs) {
        combinedQty += entry.qty;
      }
    });
  }

  var qtyToShow = best.maxDisplayQty ? Math.min(combinedQty, best.maxDisplayQty) : combinedQty;
  // Display honesty (Stathis, 7 Aug): when the merchant display cap bites,
  // render "50+" rather than a bare "50", so a capped count never reads as
  // an exact one. Numeric qtyToShow is kept for any consumer doing math.
  var qtyToShowText = String(qtyToShow) + (combinedQty > qtyToShow ? '+' : '');
  var displayDate = new Date(best.etaTs * 1000).toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
  });

  // --- DEBUG STEP 1: who won? ---
  console.log('[ETA][WH] winner:', {
    name: best.name,
    qty: best.qty,
    combinedQty: combinedQty,
    qtyToShow: qtyToShow,
    etaDays: best.etaDays,
    displayDate: displayDate
  });
  // -------------------------------

  return {
    path: 'warehouse',
    qtyToShow: qtyToShow,
    qtyToShowText: qtyToShowText,
    displayDate: displayDate,
    etaDays: best.etaDays,
    displayAsStore: best.displayAsStore,
    storeLink: best.storeLink,
    isManufacturerInventorySource: best.isManufacturerInventorySource,
    isExternalWarehouseSource: best.isExternalWarehouseSource,
    best: best,
    candidates: candidates,
    debug: {
      market: market,
      inventoryByLocation: inventoryByLocation,
      candidates: candidates,
      winner: {
        name: best.name,
        shipByISO: best.shipByISO,
        etaDays: best.etaDays,
        etaTs: best.etaTs,
        qty: best.qty,
        qtyToShow: qtyToShow,
        displayDate: displayDate,
        displayAsStore: best.displayAsStore,
        storeLink: best.storeLink,
        isManufacturerInventorySource: best.isManufacturerInventorySource,
        isExternalWarehouseSource: best.isExternalWarehouseSource
      },
      rules: [
        'Only enabled fulfillment sources are considered.',
        'Region visibility must include the current market (' + market + ').',
        'Location must have on-hand quantity.',
        'Lowest ETA wins. If combine_same_eta is true, quantities with matching ETA are combined.'
      ]
    }
  };
}


  function computeTurn14(config) {
    var etaObj = config.turn14 || {};
    var availList = Array.isArray(etaObj.availability) ? etaObj.availability : [];
    if (!availList.length) return null;

    var todayTs = (config.todayTs || Date.now() / 1000);
    var today = new Date(todayTs * 1000);
    var todayStartTs = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime() / 1000;
    var marketIsUS = config.market === 'US';

    var buffers = Array.isArray(config.warehouseBuffers) ? config.warehouseBuffers : [];
    function getBuffer(state) {
      if (marketIsUS) return { base: 0, buf: 0 };
      var match = buffers.find(function(b) {
        return b && extractField(b, 'enabled') && extractField(b, 'warehouse_state_code') === state;
      });
      return match
        ? {
            base: toNumber(extractField(match, 'fixed_shipping_days')),
            buf: toNumber(extractField(match, 'buffer_days'))
          }
        : { base: 0, buf: 0 };
    }

    var best = null;
    var anyStock = availList.some(function(entry) {
      if (!entry) return false;
      return toNumber(entry.Quantity || entry.qty) > 0;
    });
    var anyEta = false;
    var hasPastEta = false;
    var hasFutureEta = false;
    var manufacturerStock = toNumber(
      etaObj.manufacturerStock ||
      etaObj.ManufacturerStock ||
      etaObj.manufacturer_stock
    );
    var manufacturerEstimatedShipDate =
      etaObj.manufacturerEstimatedShipDate ||
      etaObj.ManufacturerEstimatedShipDate ||
      etaObj.manufacturerEsd ||
      etaObj.ManufacturerEsd ||
      etaObj.manufacturer_esd ||
      null;
    var manufacturerStockShippingDays = toNumber(config.manufacturerStockShippingDays);
    if (manufacturerStockShippingDays <= 0) manufacturerStockShippingDays = 5;
    var manufacturerBest = null;

    availList.forEach(function(entry) {
      if (!entry) return;
      var qty = toNumber(entry.Quantity || entry.qty);

      // If any source has inventory, only evaluate in-stock sources.
      // This prevents zero-quantity sources from winning the ETA ranking
      // when an in-stock source exists.
      if (anyStock && qty <= 0) return;

      var etaTsRaw = null;
      var etaIsPast = false;
      if (entry.EstimatedShipDate) {
        etaTsRaw = Date.parse(entry.EstimatedShipDate + 'T00:00:00Z') / 1000;
        if (!isNaN(etaTsRaw)) {
          anyEta = true;
          if (etaTsRaw < todayStartTs) {
            hasPastEta = true;
            etaIsPast = true;
          } else {
            hasFutureEta = true;
          }
        }
      }

      // v3 Layer B: in-stock CA units follow the weekly T14 inbound cycle
      // instead of static buffers, when the calendar is present. Fallback to
      // buffers whenever the cycle cannot compute (decision 5).
      //
      // The enabled flag is string-coerced like every other config flag
      // (see the fulfillment-source pattern above). Found the hard way on
      // 8 Aug: a metafield type drift to single_line_text_field made the
      // Liquid render the STRING "false", which is truthy, silently forcing
      // the cycle ON with the kill switch visually off.
      var gvCycleOn = false;
      if (config.t14Cycle) {
        var gvCe = config.t14Cycle.enabled;
        gvCycleOn = gvCe === true || gvCe === 1 || gvCe === '1' || gvCe === 'true';
      }
      if (qty > 0 && !marketIsUS && config.etaCalendarSets && gvCycleOn) {
        var st = (entry.LocationState || '').toString().toUpperCase();
        if (st === 'PA' || st === 'IN' || st === 'TX' || st === 'NV') {
          var cycle = computeT14CycleShip(st, todayTs, config.etaCalendarSets);
          if (cycle) {
            var cycleTotalDays = countBusinessDaysBetween(todayTs, cycle.shipTs);
            // Tie-break on quantity: PA/IN/TX share one weekly cycle and tie
            // to the day, so feed order used to win and the shallowest
            // warehouse's count got displayed (TX's 6 over PA's 32). Prefer
            // the deepest warehouse among equal ship dates; dates unchanged.
            if (!best || cycle.shipTs < best.displayTsNum ||
                (cycle.shipTs === best.displayTsNum && qty > best.qty)) {
              best = {
                totalDays: cycleTotalDays,
                qty: qty,
                displayTsNum: cycle.shipTs,
                shipByISO: cycle.shipIso,
                cycle: cycle,
                displayDate: fmtIsoShort(cycle.shipIso)
              };
            }
            return;
          }
        }
      }

      var baseBusinessDays = null;
      if (qty > 0) {
        baseBusinessDays = 1;
      } else if (etaTsRaw && !etaIsPast) {
        baseBusinessDays = countBusinessDaysBetween(todayTs, etaTsRaw);
      }

      if (baseBusinessDays !== null) {
        var totalDays = baseBusinessDays;
        if (marketIsUS) {
          totalDays += qty > 0 ? toNumber(config.usInStockBuffer) : toNumber(config.usOutOfStockBuffer);
        } else {
          var buf = getBuffer(entry.LocationState);
          totalDays += buf.base + buf.buf;
        }
        var displayTs = computeBusinessDisplayDate(totalDays, todayTs, config.holidaySet);

        // Tie-break on quantity (v6.7), mirroring the cycle branch above. In
        // the US market every in-stock Turn14 warehouse gets the same buffer,
        // so they always tie to the day and feed order decided which count
        // was displayed (TX's 6 over PA's 32). Prefer the deepest warehouse
        // among equal ship dates; the date itself is unchanged.
        if (!best || displayTs < best.displayTsNum ||
            (displayTs === best.displayTsNum && qty > best.qty)) {
          best = {
            totalDays: totalDays,
            qty: qty,
            displayTsNum: displayTs,
            shipByISO: localIsoOf(displayTs),
            displayDate: new Date(displayTs * 1000).toLocaleDateString('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric'
            })
          };
        }
      }
    });

    if (!anyStock && manufacturerStock > 0) {
      var manufacturerTotalDays = manufacturerStockShippingDays;
      var manufacturerDisplayTs = computeBusinessDisplayDate(manufacturerTotalDays, todayTs, config.holidaySet);
      manufacturerBest = {
        totalDays: manufacturerTotalDays,
        qty: manufacturerStock,
        shipDays: manufacturerStockShippingDays,
        source: 'manufacturer',
        manufacturerEstimatedShipDate: manufacturerEstimatedShipDate,
        displayDate: new Date(manufacturerDisplayTs * 1000).toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })
      };

      best = manufacturerBest;
    }

    var treatAsNoConfirmedEta = !anyStock && manufacturerStock <= 0 && anyEta && hasPastEta && !hasFutureEta;
    return {
      path: 'turn14',
      best: best,
      treatAsNoConfirmedEta: treatAsNoConfirmedEta,
      anyStock: anyStock,
      manufacturerStock: manufacturerStock,
      debug: {
        market: marketIsUS ? 'US' : 'CA',
        availabilityEntries: availList,
        best: best,
        anyStock: anyStock,
        manufacturerStock: manufacturerStock,
        manufacturerEstimatedShipDate: manufacturerEstimatedShipDate,
        manufacturerStockShippingDays: manufacturerStockShippingDays,
        manufacturerBest: manufacturerBest,
        anyEta: anyEta,
        hasPastEta: hasPastEta,
        hasFutureEta: hasFutureEta,
        treatAsNoConfirmedEta: treatAsNoConfirmedEta,
        bufferRules: marketIsUS
          ? 'US market uses usInStockBuffer/usOutOfStockBuffer.'
          : 'CA market uses per-warehouse state buffers when ETA is present.'
      }
    };
  }

  function computeVendorFallback(config) {
    var vendorName = (config.vendor || '').toString();
    if (!vendorName) return null;

    function norm(str) {
      return (str || '').toString().trim().toLowerCase();
    }

    var groups = Array.isArray(config.vendorGroups) ? config.vendorGroups : [];
    var assignments = Array.isArray(config.vendorAssignments) ? config.vendorAssignments : [];

    var assignment = assignments.find(function(entry) {
      return entry && norm(extractField(entry, 'vendor_name')) === norm(vendorName);
    });

    function resolveGroupKey(ref) {
      if (!ref) return null;

      var direct = [
        extractField(ref, 'id'),
        extractField(ref, 'gid'),
        extractField(ref, 'key'),
        extractField(ref, 'handle'),
        extractField(ref, 'internal_key')
      ].find(function(val) { return !!val; });
      if (direct) return direct;

      if (ref.reference) {
        var viaReference = resolveGroupKey(ref.reference);
        if (viaReference) return viaReference;
      }

      if (ref.metaobject) {
        var viaMetaobject = resolveGroupKey(ref.metaobject);
        if (viaMetaobject) return viaMetaobject;
      }

      if (ref.value && ref.value !== ref) {
        return resolveGroupKey(ref.value);
      }

      return ref;
    }

    var groupKey = assignment ? resolveGroupKey(extractField(assignment, 'eta_group')) : null;
    var groupEta = assignment ? extractField(assignment, 'group_eta') : null;

    var normAssignmentKeys = [groupKey, groupEta]
      .map(norm)
      .filter(function(val) { return !!val; });

    var group = groups.find(function(entry) {
      var candidates = [
        extractField(entry, 'id'),
        extractField(entry, 'gid'),
        extractField(entry, 'key'),
        extractField(entry, 'internal_key'),
        extractField(entry, 'handle'),
        extractField(entry, 'name')
      ].map(norm);
      return normAssignmentKeys.some(function(assignmentKey) {
        return candidates.some(function(val) { return val && val === assignmentKey; });
      });
    });

    if (!group) return null;

    var behavior = extractField(group, 'behavior');
    var title = extractField(group, 'static_message_title');
    var body = extractField(group, 'static_message_body');
    var checkboxLabel = extractField(group, 'checkbox_label');

    if (body && typeof body === 'object') {
      if (typeof body.value !== 'undefined') {
        body = body.value;
      } else if (typeof body.body !== 'undefined') {
        body = body.body;
      }
    }

    if (checkboxLabel && typeof checkboxLabel === 'object') {
      if (typeof checkboxLabel.value !== 'undefined') {
        checkboxLabel = checkboxLabel.value;
      } else if (typeof checkboxLabel.text !== 'undefined') {
        checkboxLabel = checkboxLabel.text;
      }
    }

    if ((behavior || '').toLowerCase() === 'dynamic eta' || (behavior || '').toLowerCase() === 'dynamic') {
      var etaDays = toNumber(extractField(group, 'fixed_business_days')) + toNumber(extractField(group, 'buffer_days'));
      var etaTs = computeBusinessDisplayDate(etaDays, config.todayTs);
      var displayDate = new Date(etaTs * 1000).toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric'
      });
      return {
        path: 'vendor-dynamic',
        badgeState: 'special',
        displayDate: displayDate,
        etaDays: etaDays,
        noteValue: 'Yes — Special order, ship by ' + displayDate + ', final sale',
        ackText: checkboxLabel || null,
        message: badgeHtml('special', 'Special order', 'i') + 'Typically ships in about ' + etaDays + ' business days.<div class="eta-block">Estimated ship date: <strong>' + displayDate + '</strong></div><div class="eta-block eta-nocancel"><strong>Special order:</strong> cannot be cancelled or refunded once ordered.</div>',
        debug: {
          vendor: vendorName,
          assignmentKey: groupKey || groupEta,
          behavior: behavior,
          bufferDays: toNumber(extractField(group, 'buffer_days')),
          fixedDays: toNumber(extractField(group, 'fixed_business_days')),
          messageTitle: title,
          messageBody: body,
          assignmentRaw: assignment,
          groupRaw: group,
          mode: 'dynamic'
        }
      };
    }

    var vendorStaticText = ((title || '') + ' ' + (body || '')).toLowerCase();
    var isMadeToOrder = vendorStaticText.indexOf('made to order') !== -1 || vendorStaticText.indexOf('made-to-order') !== -1;
    // Static groups may still carry fixed_business_days (made-to-order
    // "15 to 30 business days" uses 30, the conservative upper bound) so the
    // machine note gets a parseable ship-by date the checkout validation can
    // freshness-check, instead of the old dateless "no ETA".
    var staticDays = toNumber(extractField(group, 'fixed_business_days')) + toNumber(extractField(group, 'buffer_days'));
    var staticShipBy = null;
    if (staticDays > 0) {
      var staticTs = computeBusinessDisplayDate(staticDays, config.todayTs);
      staticShipBy = new Date(staticTs * 1000).toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric'
      });
    }
    var staticNoteTail = staticShipBy ? 'ship by ' + staticShipBy : 'no confirmed ship date';
    return {
      path: 'vendor-static',
      badgeState: isMadeToOrder ? 'madetoorder' : 'special',
      madeToOrder: isMadeToOrder,
      displayDate: staticShipBy || undefined,
      noteValue: (isMadeToOrder ? 'Yes — Made to order, ' : 'Yes — Special order, ') + staticNoteTail + ', final sale',
      title: title || 'Special Order',
      body: body || 'Special order item with no confirmed ship date. Contact sales@raptorracing.com for info.',
      ackText: checkboxLabel || (isMadeToOrder ? 'I understand this item is made to order with no confirmed ship date and cannot be cancelled once ordered.' : null),
      debug: {
        vendor: vendorName,
        assignmentKey: groupKey || groupEta,
        behavior: behavior,
        messageTitle: title,
        messageBody: body,
        assignmentRaw: assignment,
        groupRaw: group,
        mode: 'static'
      }
    };
  }

  function badgeHtml(state, label, icon) {
    return '<div class="eta-badge eta-badge--' + state + '"><span class="eta-badge__icon" aria-hidden="true">' + icon + '</span><span>' + label + '</span></div>';
  }

  function compute(config) {
    var todayTs = config.todayTs || Date.now() / 1000;
    var baseConfig = Object.assign({}, config, { todayTs: todayTs });
    var isCanadaMarket = config.market === 'CA';
    var etaSets = isCanadaMarket ? calendarSets(config.etaCalendar) : null;
    var onHolidaySet = etaSets ? etaSets.on : undefined;
    var defaultAckText = 'I understand the estimated shipping time is an approximation and may change.';
    var canadaAckText = 'I understand the estimated ship / pickup date is an approximation and may change.';
    var manufacturerUsAckText = 'I understand the estimated shipping date is an approximation and may change.';
    var warehousePickupNotice = '<strong>No same-day pickup available.</strong></div><div class="eta-block">Estimated pickup or ship date: ';
    var etaTransitNote = '<div class="eta-block eta-transit-note" style="font-size:0.85em;opacity:0.78;margin-top:2px">Delivery takes additional transit time based on your location.</div>';

    var vendorAttempt = computeVendorFallback({
      vendor: config.vendor,
      vendorGroups: config.vendorGroups,
      vendorAssignments: config.vendorAssignments,
      todayTs: todayTs
    });

    var warehouseResult = selectWarehouses({
      market: config.market,
      inventoryMap: config.inventoryMap,
      inventoryVariantId: config.inventoryVariantId,
      fulfillmentSources: config.fulfillmentSources,
      todayTs: todayTs,
      holidaySet: onHolidaySet
    });

    var turn14Result = computeTurn14({
      turn14: config.turn14,
      warehouseBuffers: config.warehouseBuffers,
      usInStockBuffer: config.usInStockBuffer,
      usOutOfStockBuffer: config.usOutOfStockBuffer,
      manufacturerStockShippingDays: config.manufacturerStockShippingDays,
      market: config.market,
      todayTs: todayTs,
      etaCalendarSets: etaSets,
      t14Cycle: config.t14Cycle,
      holidaySet: onHolidaySet
    });
    var turn14HasAvailableStock = turn14Result &&
      turn14Result.best &&
      !turn14Result.treatAsNoConfirmedEta &&
      turn14Result.best.qty > 0;
    var useTurn14OverWarehouse = warehouseResult &&
      turn14HasAvailableStock &&
      turn14Result.best.totalDays < warehouseResult.etaDays;

    if (warehouseResult && !useTurn14OverWarehouse) {
      var warehouseDebug = {
        warehouse: warehouseResult.debug,
        turn14: turn14Result && turn14Result.debug,
        vendor: vendorAttempt && vendorAttempt.debug,
        finalPath: 'warehouse'
      };
      var storeText = warehouseResult.isExternalWarehouseSource ? 'external warehouse' : 'warehouse';
      if (warehouseResult.displayAsStore) {
        storeText = warehouseResult.storeLink
          ? '<a href="' + warehouseResult.storeLink + '" target="_blank" rel="noopener">store</a>'
          : 'store';
      }
      var whBadgeState = warehouseResult.isManufacturerInventorySource ? 'manufacturer' : (warehouseResult.displayAsStore ? 'local' : 'warehouse');
      var whBadge = whBadgeState === 'local'
        ? badgeHtml('local', 'In stock locally', '&#10003;')
        : whBadgeState === 'manufacturer'
          ? badgeHtml('manufacturer', 'Manufacturer stock', '&#10003;')
          : badgeHtml('warehouse', 'Warehouse stock', '&#10003;');
      var gvWhQty = warehouseResult.qtyToShowText || String(warehouseResult.qtyToShow);
      var warehouseMessage = whBadge + '<b>' + gvWhQty + '</b> available in our ' + storeText + '.<div class="eta-block">Ships approx. <strong>' + warehouseResult.displayDate + '</strong></div>';

      if (warehouseResult.isManufacturerInventorySource) {
        warehouseDebug.finalPath = 'manufacturer-inventory';
        var manufacturerInventoryVendorName = (config.vendor || 'the manufacturer').toString().trim() || 'the manufacturer';
        var manufacturerInventoryQtyText = '<b>' + gvWhQty + '</b> available at <b>' + escapeHtml(manufacturerInventoryVendorName) + '</b>';
        warehouseMessage = isCanadaMarket
          ? whBadge + manufacturerInventoryQtyText + '<div class="eta-block"><strong>No same-day pickup available.</strong></div><div class="eta-block">Estimated pickup or ship date: <strong>' + warehouseResult.displayDate + '</strong></div>' + etaTransitNote
          : whBadge + manufacturerInventoryQtyText + '<div class="eta-block">Ships direct from manufacturer by approx. <strong>' + warehouseResult.displayDate + '</strong></div>';
      } else if (isCanadaMarket) {
        if (warehouseResult.displayAsStore) {
          warehouseMessage = badgeHtml('local', 'In stock locally', '&#10003;') + '<b>' + gvWhQty + '</b> in our ' + storeText + '.<div class="eta-block"><strong>Same Day Pickup</strong>, or ships approx. <strong>' + warehouseResult.displayDate + '</strong></div>' + etaTransitNote;
        } else {
          warehouseMessage = whBadge + '<b>' + gvWhQty + '</b> available in our ' + storeText + '.<div class="eta-block">' + warehousePickupNotice + '<strong>' + warehouseResult.displayDate + '</strong></div>' + etaTransitNote;
        }
      }

      return {
        path: warehouseResult.isManufacturerInventorySource ? 'manufacturer-inventory' : 'warehouse',
        badgeState: whBadgeState,
        qtyToShow: warehouseResult.qtyToShow,
        displayDate: warehouseResult.displayDate,
        noteValue: 'Yes — ' + (whBadgeState === 'local' ? 'In stock locally' : (whBadgeState === 'manufacturer' ? 'Manufacturer stock' : (warehouseResult.isExternalWarehouseSource ? 'Ext. warehouse stock' : 'Warehouse stock'))) + ', ship by ' + warehouseResult.displayDate,
        ackText: warehouseResult.isManufacturerInventorySource && !isCanadaMarket ? manufacturerUsAckText : (isCanadaMarket ? canadaAckText : defaultAckText),
        message: warehouseMessage,
        debug: warehouseDebug
      };
    }

    if (turn14Result && turn14Result.best && !turn14Result.treatAsNoConfirmedEta) {
      var turn14Debug = {
        warehouse: warehouseResult && warehouseResult.debug,
        turn14: turn14Result.debug,
        vendor: vendorAttempt && vendorAttempt.debug,
        finalPath: turn14Result.best.source === 'manufacturer' ? 'turn14-manufacturer' : 'turn14'
      };
      var isManufacturerStock = turn14Result.best.source === 'manufacturer';
      var isOutOfStock = !(turn14Result.best.qty > 0);
      var qtyText = badgeHtml('oos', 'Out of stock', '!');
      if (!isOutOfStock && isManufacturerStock) {
        var manufacturerVendorName = (config.vendor || 'the manufacturer').toString().trim() || 'the manufacturer';
        qtyText = badgeHtml('manufacturer', 'Manufacturer stock', '&#10003;') + '<b>' + (turn14Result.best.qty > 50 ? '50+' : String(turn14Result.best.qty)) + '</b> available at <b>' + escapeHtml(manufacturerVendorName) + '</b>';
      } else if (!isOutOfStock) {
        qtyText = badgeHtml('warehouse', 'Warehouse stock', '&#10003;') + '<b>' + (turn14Result.best.qty > 10 ? '10+' : String(turn14Result.best.qty)) + '</b> in our external warehouse.';
      }
      // OOS: displayDate is the RESTOCK ESTIMATE plus the same state shipping
      // buffers an in-stock unit gets, i.e. a projected SHIP date. The old
      // label ("Restock approx. <date>") presented that buffered date as the
      // restock date, understating the wait (Stathis, 7 Aug).
      var message = isOutOfStock
        ? qtyText + '<div class="eta-block">Estimated ship date after restock: <strong>' + turn14Result.best.displayDate + '</strong><br>Order now to reserve yours.</div>'
        : isManufacturerStock && isCanadaMarket
          ? qtyText + '<div class="eta-block"><strong>No same-day pickup available.</strong></div><div class="eta-block">Estimated pickup or ship date: <strong>' + turn14Result.best.displayDate + '</strong></div>' + etaTransitNote
          : isManufacturerStock
            ? qtyText + '<div class="eta-block">Ships direct from manufacturer by approx. <strong>' + turn14Result.best.displayDate + '</strong></div>'
          : qtyText + '<div class="eta-block">Ships approx. <strong>' + turn14Result.best.displayDate + '</strong></div>';
      if (isCanadaMarket && !isOutOfStock && !isManufacturerStock) {
        message = qtyText + '<div class="eta-block">' + warehousePickupNotice + '<strong>' + turn14Result.best.displayDate + '</strong></div>' + etaTransitNote;
      }
      var turn14NoteValue = isOutOfStock
        ? 'Yes — Out of stock, ship by ' + turn14Result.best.displayDate + ' (after restock)'
        : (isManufacturerStock
            ? 'Yes — Manufacturer stock, ship by ' + turn14Result.best.displayDate
            : 'Yes — Ext. warehouse stock, ship by ' + turn14Result.best.displayDate);
      return {
        path: 'turn14',
        badgeState: isOutOfStock ? 'oos' : (isManufacturerStock ? 'manufacturer' : 'warehouse'),
        displayDate: turn14Result.best.displayDate,
        noteValue: turn14NoteValue,
        ackText: isOutOfStock
          ? 'I understand this item is <strong>out of stock</strong> and the estimated ship date after restock may change.'
          : (isManufacturerStock && !isCanadaMarket ? manufacturerUsAckText : (isCanadaMarket ? canadaAckText : defaultAckText)),
        message: message,
        debug: turn14Debug
      };
    }

    var vendorResult = vendorAttempt;

    if (vendorResult) {
      var vendorDebug = {
        warehouse: warehouseResult && warehouseResult.debug,
        turn14: turn14Result && turn14Result.debug,
        vendor: vendorResult.debug,
        finalPath: vendorResult.path
      };
      if (vendorResult.path === 'vendor-dynamic') {
        return Object.assign({}, vendorResult, {
          ackText: vendorResult.ackText || 'I understand this is a <strong>special order</strong> with an estimated ship date that may change, and that it cannot be cancelled or refunded once ordered.',
          debug: vendorDebug
        });
      }
      return Object.assign({}, vendorResult, {
        isSpecialOrder: true,
        ackText: vendorResult.ackText || 'I understand this is a <strong>special order</strong> with no confirmed ship date and that it cannot be cancelled or refunded once ordered.',
        debug: vendorDebug
      });
    }

    var hasTurn14Partnumber = config.turn14 && (config.turn14.partnumber || config.turn14.partNumber || config.turn14.part_number);
    var unknownMessage = badgeHtml('special', 'Special order', 'i') + (isCanadaMarket
      ? 'No confirmed ship date. Contact <a href="mailto:sales@raptorracing.com">sales@raptorracing.com</a>'
      : 'No confirmed ETA — contact <a href="mailto:sales@raptorracing.com">sales@raptorracing.com</a>')
      + '<div class="eta-block eta-nocancel"><strong>Special order:</strong> cannot be cancelled or refunded once ordered.</div>';
    return {
      path: 'unknown',
      badgeState: 'special',
      noteValue: 'Yes — Special order, no confirmed ship date, final sale',
      ackText: 'I understand this is a <strong>special order</strong> with no confirmed ship date and that it cannot be cancelled or refunded once ordered.',
      message: unknownMessage,
      debug: {
        warehouse: warehouseResult && warehouseResult.debug,
        turn14: turn14Result && turn14Result.debug,
        vendor: vendorAttempt && vendorAttempt.debug,
        finalPath: 'unknown'
      }
    };
  }


  // ---------------------------------------------------------------------
  // Quantity-aware wrapper. Builds a unified stock pool — theme fulfillment
  // sources (store/warehouses) PLUS Turn14 warehouses PLUS Turn14
  // manufacturer stock — sorted by ETA, then walks it until the requested
  // quantity is covered. The SLOWEST source needed governs the line's ETA,
  // computed natively by masking faster sources out of the engine's inputs.
  // If the whole pool cannot cover the quantity, falls through to the
  // vendor/special-order path and flags the true shortfall.
  // ---------------------------------------------------------------------
  function computeForQuantity(config, quantity) {
    var qtyRequested = Math.max(1, toNumber(quantity) || 1);
    var base = compute(config);
    if (qtyRequested <= 1) return base;

    var todayTs = config.todayTs || Date.now() / 1000;
    var sources = Array.isArray(config.fulfillmentSources) ? config.fulfillmentSources : [];

    // --- pool part 1: theme fulfillment sources ---
    var pool = [];
    var etaSetsQ = config.market === 'CA' ? calendarSets(config.etaCalendar) : null;
    var wh = selectWarehouses({
      market: config.market,
      inventoryMap: config.inventoryMap,
      inventoryVariantId: config.inventoryVariantId,
      fulfillmentSources: config.fulfillmentSources,
      todayTs: todayTs,
      holidaySet: etaSetsQ ? etaSetsQ.on : undefined
    });
    if (wh && wh.candidates) {
      wh.candidates.forEach(function(c) {
        pool.push({
          kind: 'wh',
          days: c.etaDays,
          qty: c.qty,
          idx: c.idx,
          label: c.displayAsStore ? 'in our store'
            : c.isManufacturerInventorySource ? 'at the manufacturer'
            : c.isExternalWarehouseSource ? 'in our external warehouse'
            : 'in our warehouse'
        });
      });
    }

    // --- pool part 2: Turn14 warehouses (probe each entry alone so the
    //     engine's own buffer math prices its ETA) ---
    var t14Obj = config.turn14 || {};
    var availEntries = Array.isArray(t14Obj.availability) ? t14Obj.availability : [];
    var t14Common = {
      warehouseBuffers: config.warehouseBuffers,
      usInStockBuffer: config.usInStockBuffer,
      usOutOfStockBuffer: config.usOutOfStockBuffer,
      manufacturerStockShippingDays: config.manufacturerStockShippingDays,
      market: config.market,
      todayTs: todayTs,
      etaCalendarSets: etaSetsQ,
      t14Cycle: config.t14Cycle,
      holidaySet: etaSetsQ ? etaSetsQ.on : undefined
    };
    availEntries.forEach(function(entry, i) {
      if (!entry) return;
      var q = toNumber(entry.Quantity || entry.qty);
      if (q <= 0) return;
      var probe = computeTurn14(Object.assign({}, t14Common, {
        turn14: { availability: [entry] }
      }));
      if (probe && probe.best && !probe.treatAsNoConfirmedEta) {
        pool.push({ kind: 't14', days: probe.best.totalDays, qty: q, entryIndex: i, label: 'in our external warehouse' });
      }
    });

    // --- pool part 3: Turn14 manufacturer stock ---
    var mfrUnits = toNumber(
      t14Obj.manufacturerStock || t14Obj.ManufacturerStock || t14Obj.manufacturer_stock
    );
    if (mfrUnits > 0) {
      var mfrProbe = computeTurn14(Object.assign({}, t14Common, {
        turn14: {
          availability: [{ Quantity: 0 }],
          manufacturerStock: mfrUnits,
          manufacturerEstimatedShipDate: t14Obj.manufacturerEstimatedShipDate || t14Obj.ManufacturerEstimatedShipDate || null
        }
      }));
      if (mfrProbe && mfrProbe.best) {
        pool.push({ kind: 'mfr', days: mfrProbe.best.totalDays, qty: mfrUnits, label: 'at the manufacturer' });
      }
    }

    // No real stock anywhere: made-to-order / special-order items need no
    // quantity treatment — the base result already says it all.
    if (!pool.length) return base;

    // Equal-day ordering (v6.7): theme sources, then Turn14, then
    // manufacturer (the push order a stable sort already preserved), and
    // among equal-day Turn14 entries the deepest first, so the warehouse
    // that wins the single-unit ranking also fills multi-unit orders first
    // and the allocation text stays consistent with the product-page count.
    function poolKindRank(k) { return k === 'wh' ? 0 : k === 't14' ? 1 : 2; }
    pool.sort(function(a, b) {
      if (a.days !== b.days) return a.days - b.days;
      var ka = poolKindRank(a.kind), kb = poolKindRank(b.kind);
      if (ka !== kb) return ka - kb;
      if (ka === 1 && a.qty !== b.qty) return b.qty - a.qty;
      return 0;
    });

    var cumulative = 0;
    var needed = [];
    for (var i = 0; i < pool.length; i++) {
      cumulative += pool[i].qty;
      needed.push(pool[i]);
      if (cumulative >= qtyRequested) break;
    }

    var flat = buildInventoryMap(config.inventoryMap, config.inventoryVariantId);

    function buildAllocation() {
      var remaining = qtyRequested;
      var allocs = [];
      needed.forEach(function(c) {
        var take = Math.min(c.qty, remaining);
        remaining -= take;
        if (take <= 0) return;
        var last = allocs[allocs.length - 1];
        if (last && last.label === c.label) { last.take += take; }
        else { allocs.push({ take: take, label: c.label }); }
      });
      return allocs;
    }

    function applyAllocation(result) {
      var allocs = buildAllocation();
      var html = allocs.map(function(a) { return '<b>' + a.take + '</b> ' + a.label; }).join(' + ') + '.';
      var text = allocs.map(function(a) { return a.take + ' ' + a.label; }).join(' + ');
      var qtySentence = /<b>\d+\+?<\/b>[^<]*/;
      var applied = false;
      var governingKind = needed[needed.length - 1].kind;
      if (result.message && governingKind !== 'mfr' && qtySentence.test(result.message)) {
        result.message = result.message.replace(qtySentence, html);
        applied = true;
      } else if (result.message) {
        result.message += '<div class="eta-block">' + html + '</div>';
        applied = true;
      }
      result.quantitySplit = {
        requested: qtyRequested,
        immediate: needed.length > 1 ? needed[0].qty : qtyRequested,
        sources: needed.map(function(c) { return { kind: c.kind, qty: c.qty, etaDays: c.days }; })
      };
      result.quantityAllocation = { html: html, text: text, applied: applied };
      return result;
    }

    if (cumulative >= qtyRequested) {
      if (needed.length === 1) return base;

      var governing = needed[needed.length - 1];

      // Mask theme locations consumed by faster wh entries (or all of them
      // when a Turn14/manufacturer source governs).
      var masked = {};
      for (var key in flat) {
        if (Object.prototype.hasOwnProperty.call(flat, key)) masked[key] = flat[key];
      }
      needed.forEach(function(c, idx2) {
        if (c.kind !== 'wh') return;
        if (idx2 === needed.length - 1) return; // governing keeps its stock
        var src2 = sources[c.idx];
        var locId = src2 ? extractField(src2, 'shopify_location_id') : null;
        if (locId != null) masked[String(locId)] = 0;
      });
      if (governing.kind !== 'wh') {
        for (var key2 in masked) {
          if (Object.prototype.hasOwnProperty.call(masked, key2)) masked[key2] = 0;
        }
      }

      // Filter Turn14 inputs so nothing faster than the governing source can
      // win the engine's internal ranking.
      var turn14Adjusted = null;
      if (governing.kind === 'mfr') {
        turn14Adjusted = Object.assign({}, t14Obj, { availability: [{ Quantity: 0 }] });
      } else {
        var keepIndexes = {};
        pool.forEach(function(c) {
          if (c.kind !== 't14') return;
          if (c.days >= governing.days || c === governing) keepIndexes[c.entryIndex] = true;
        });
        if (governing.kind === 't14') keepIndexes[governing.entryIndex] = true;
        var filtered = availEntries.filter(function(entry, i3) { return keepIndexes[i3]; });
        turn14Adjusted = Object.assign({}, t14Obj, {
          availability: filtered,
          manufacturerStock: 0,
          ManufacturerStock: 0,
          manufacturer_stock: 0
        });
        if (governing.kind === 'wh') {
          // Governing theme source: drop faster Turn14 entries entirely; the
          // remaining (slower) ones must not outrank it either — compute
          // prefers Turn14 only when strictly faster, so this is safe.
          turn14Adjusted.availability = filtered.filter(function(entry) {
            var q3 = toNumber(entry && (entry.Quantity || entry.qty));
            return q3 > 0;
          });
        }
      }

      var governed = compute(Object.assign({}, config, {
        inventoryMap: { locations: masked },
        turn14: turn14Adjusted,
        todayTs: todayTs
      }));
      return applyAllocation(governed);
    }

    // Requested quantity exceeds ALL known stock: vendor/special-order path
    // with the true availability count.
    var emptied = {};
    for (var key4 in flat) {
      if (Object.prototype.hasOwnProperty.call(flat, key4)) emptied[key4] = 0;
    }
    var fallback = compute(Object.assign({}, config, {
      inventoryMap: { locations: emptied },
      turn14: null,
      todayTs: todayTs
    }));
    fallback.quantityShortfall = { requested: qtyRequested, available: cumulative };
    fallback.noteValue = fallback.noteValue + ' (only ' + cumulative + ' of ' + qtyRequested + ' in stock now)';
    return fallback;
  }


  window.RaptorEta = {
  compute: compute,
  computeForQuantity: computeForQuantity,
  helpers: {
    parseJSONSafe: parseJSONSafe,
    toNumber: toNumber,
    bumpWeekend: bumpWeekend,
    countBusinessDaysBetween: countBusinessDaysBetween,
    computeDisplayDate: computeDisplayDate,
    computeBusinessDisplayDate: computeBusinessDisplayDate,
    torontoParts: torontoParts,
    calendarSets: calendarSets,
    resolveShipDay: resolveShipDay,
    computeT14CycleShip: computeT14CycleShip
  }
};
})();
